import 'rxjs/add/operator/toPromise';

import { Injectable } from '@angular/core';

import { Api } from '../../api/api';

/**
 * Most apps have the concept of a User. This is a simple provider
 * with stubs for login/signup/etc.
 *
 * This User provider makes calls to our API at the `login` and `signup` endpoints.
 *
 * By default, it expects `login` and `signup` to return a JSON object of the shape:
 *
 * ```json
 * {
 *   status: 'success',
 *   user: {
 *     // User fields your app needs, like "id", "name", "email", etc.
 *   }
 * }Ø
 * ```
 *
 * If the `status` field is not `success`, then an error is detected and returned.
 */
@Injectable()
export class Employee {
  
    constructor(public api: Api) { }

    getInfo(params?: any) {
        let seq = this.api.get('index.php/attendance/App/info_attendance', params);
        return seq;
    }

    getListMyAttendance(params?: any) {
        let seq = this.api.get('index.php/attendance/App', params);
        return seq;
    }

    getListBawahanAttendance(params?: any) {
        let seq = this.api.get('index.php/attendance/App/attendance_bawahan', params);
        return seq;
    }

    addAttendance(params?:any){
        let seq = this.api.post('index.php/attendance/App/add', params);
        return seq;
    }
}



// WEBPACK FOOTER //
// ./src/providers/attendance/employee/employee.ts